import _forEach from "lodash/forEach";
import _get from "lodash/get";
import "core-js/modules/es.object.assign.js";
import React from 'react';
import classnames from 'classnames';
import { Link } from "../../Button/Link/Link";
import { Countdown } from "../../Countdown/Countdown";
import { MARK_TAGS, renderMark } from "../RichTextLeaf/RichTextLeaf";
import { VideoPlayer } from "../../Video/VideoPlayer/VideoPlayer";
export var RichTextElement = function RichTextElement(_ref) {
  var children = _ref.children,
      element = _ref.element,
      attributes = _ref.attributes;
  var tag = (element === null || element === void 0 ? void 0 : element.type) || '';

  if (element !== null && element !== void 0 && element.type) {
    switch (element.type) {
      case 'a':
        tag = Link;
        break;

      case 'countdown':
        tag = Countdown;
        break;

      case 'idMarker':
        tag = 'span';
        break;
    }
  } // Combine with Slate editor attributes


  var elementAttributes = Object.assign({}, attributes, element === null || element === void 0 ? void 0 : element.attributes);

  if ((element === null || element === void 0 ? void 0 : element.type) === 'a') {
    elementAttributes.url = _get(element, 'attributes.href');
  } // If img loading attribute has not been specified, set it to lazy


  if ((element === null || element === void 0 ? void 0 : element.type) === 'img' && !_get(element, 'attributes.loading')) {
    elementAttributes.loading = 'lazy';
  }

  if (element !== null && element !== void 0 && element.typog) {
    var typogClass = "typog-".concat(element === null || element === void 0 ? void 0 : element.typog);
    elementAttributes.className = classnames(typogClass, elementAttributes.className);
  }

  if (element !== null && element !== void 0 && element.typog2) {
    var _typogClass = "typog2-".concat(element === null || element === void 0 ? void 0 : element.typog2);

    elementAttributes.className = classnames(_typogClass, elementAttributes.className);
  } // Inline videos do not have children.


  if ((element === null || element === void 0 ? void 0 : element.type) === 'brightcove') {
    return /*#__PURE__*/React.createElement(VideoPlayer, elementAttributes);
  } // An countdown tag uses the literal HTML, and wraps it in standard inline mark tags.
  // There are no children of an embed tag.


  if ((element === null || element === void 0 ? void 0 : element.type) === 'countdown') {
    if (element.color) {
      var colorClass = "typog--".concat(element.color);
      elementAttributes.className = classnames(colorClass, elementAttributes.className);
    } // Create countdown component with element attributes


    var countdownElement = /*#__PURE__*/React.createElement(tag, elementAttributes); // Loop through and wrap itself

    _forEach(MARK_TAGS, function (mark) {
      var renderedMark = renderMark(mark, element[mark], countdownElement);

      if (renderedMark) {
        countdownElement = renderedMark;
      }
    }); // Create a span with processed MARKS wrapping.


    return /*#__PURE__*/React.createElement('span', null, countdownElement);
  }

  return /*#__PURE__*/React.createElement(tag, elementAttributes, children);
};